"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchGraphql = fetchGraphql;
var _axios = require("@ori/axios");
var _fetchErrors = require("@ori/fetch-errors");
var _tsUtils = require("@ori/ts-utils");
var _constants = require("../constants");
var _handleResponse = require("./handleResponse");
var _isEmptyObject = require("./isEmptyObject");
/**
 * Fetches data from a GraphQL server using axios library.
 *
 * @typeParam Data The expected data type returned from the GraphQL server.
 * @typeParam Variables The type of variables that the GraphQL query takes.
 * @param options Request options object.
 * @returns A promise that resolves to the requested data and any errors, or rejects with an error.
 * @throws Error When unknown error happens
 * @throws {GraphqlError} When unknown graphql error happens
 * @throws {EmptyBodyGraphqlError} When graphql server ends request with empty response
 * @throws {NonOkResponseGraphqlError} When graphql server ends request with anything than 200 HTTP status code
 */
async function fetchGraphql({
  query,
  variables,
  url,
  headers,
  timeout = _constants.DEFAULT_TIMEOUT,
  requestConfig = {},
  onError = error => {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console -- default error handler
      console.error(error);
    }
  }
}) {
  const requestData = {
    query,
    ...(variables != null && !(0, _isEmptyObject.isEmptyObject)(variables) && {
      variables
    })
  };
  try {
    const response = await _axios.axios.post('/graphql', requestData, {
      ...requestConfig,
      baseURL: new URL(url).origin,
      headers,
      timeout
    });
    return (0, _handleResponse.handleResponse)(response, {
      onSuccess: ({
        data: {
          data,
          errors
        }
      }) => {
        if ((0, _tsUtils.isNonNullable)(data)) {
          //  Avoid omitting the errors field entirely, as TypeScript won’t provide type safety for 'errors' in result checks, which can lead to brittle and less predictable code
          return {
            ...data,
            errors: Array.isArray(errors) && errors.length > 0 ? errors : []
          };
        }
        throw new _fetchErrors.EmptyBodyGraphqlError(response);
      },
      onError: () => {
        throw new _fetchErrors.NonOkResponseGraphqlError(response);
      }
    });
  } catch (error_) {
    const error = error_ instanceof Error ? error_ : new Error(String(error_));
    let rethrowError = error;

    // We need to parse that error as it would be unreadable in Application Inisights this way
    // And also would include too much info
    if (error instanceof _axios.AxiosError) {
      rethrowError = new _fetchErrors.GraphqlError(error);
    } else {
      rethrowError = error;
    }
    onError(rethrowError);
    throw rethrowError;
  }
}
//# sourceMappingURL=fetchGraphql.js.map